// Go API와 브라우저 인증 저장소를 사용하는 정적 SPA.
export const ssr = false;
export const prerender = false;
